module.exports = __webpack_public_path__ + "img/img17.8a45bc09.svg";